<template>
  <section class="main-font">
    <div class="main-title">
      <html-view :value="$t('main.font.title')" tag="h3" />
      <html-view :value="$t('main.font.subtitle')" tag="small" />
    </div>
    <div class="main-content">
      <div ref="list" class="font-list">
        <ul>
          <li v-for="(item, key) in list" :key="key" ref="li">
            <div>
              <p class="font-name">{{ $t(item.name) }}</p>
              <em class="font-character">
                <component :is="item.icon" v-if="item.icon" />
                <img
                  v-else-if="item.image"
                  :class="item.class"
                  :src="item.image"
                  :alt="item.name"
                >
              </em>
            </div>
          </li>
        </ul>
      </div>
      <router-link
        ref="goFontMore"
        :to="{name: 'Fonts', params : { 'locale' : locale === 'en' ? 'en' : undefined }}"
        tag="button"
        type="button"
        class="btn btn-fade btn-more"
        @click.native="goTop"
      >
        {{ $t('detail.seeMore') }}
      </router-link>
    </div>
  </section>
</template>

<script>
import '@/plugins/polyfill/web-animations.min'
import { mapGetters } from 'vuex'
import gtag from '@/mixins/gtag'

export default {
  components: {
    fontHanna: () => import('@/static/image/font/hanna.svg'),
    fontJua: () => import('@/static/image/font/jua.svg'),
    fontDohyeon: () => import('@/static/image/font/dohyeon.svg'),
    fontYeonsung: () => import('@/static/image/font/yeonsung.svg'),
    fontKiranghaerang: () => import('@/static/image/font/kiranghaerang.svg'),
    fontHannaair: () => import('@/static/image/font/hannaair.svg'),
    fontHannapro: () => import('@/static/image/font/hannapro.svg'),
    fontEuljiro: () => import('@/static/image/font/euljiro.svg'),
    fontEuljiro10yearslater: () => import('@/static/image/font/euljiro10yearslater.svg'),
    fontEuljirooraeorae: () => import('@/static/image/font/euljirooraeorae.svg'),
    fontKkubulim: () => import('@/static/image/font/kkubulim.svg')
  },
  mixins: [gtag],
  data () {
    return {
      list: [
        {
          name: 'main.font.hanna11YrsOld',
          icon: 'font-hanna'
        },
        {
          name: 'main.font.jua',
          icon: 'font-jua'
        },
        {
          name: 'main.font.dohyeon',
          icon: 'font-dohyeon'
        },
        {
          name: 'main.font.yeonsung',
          icon: 'font-yeonsung'
        },
        {
          name: 'main.font.kiranghaerang',
          icon: 'font-kiranghaerang'
        },
        {
          name: 'main.font.hannaAir',
          icon: 'font-hannaair'
        },
        {
          name: 'main.font.hannaPro',
          icon: 'font-hannapro'
        },
        {
          name: 'main.font.euljiro',
          icon: 'font-euljiro'
        },
        {
          name: 'main.font.euljiro10YearsLater',
          icon: 'font-euljiro10yearslater'
        },
        {
          name: 'main.font.euljiroOraeorae',
          icon: 'font-euljirooraeorae'
        },
        {
          name: 'main.font.geullim',
          image: require('@/static/image/font/baeminGeullim.png')
        },
        {
          name: 'main.font.kkubulim',
          icon: 'font-kkubulim'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE'
    })
  },
  mounted () {
    this.scrolling()

    this.$nextTick(() => {
      this.initGtag({
        element: this.$refs.goFontMore.$el,
        ga: {
          name: '메인_글꼴 더보기',
          category: '메인_글꼴 더보기',
          label: '글꼴',
          page: '메인'
        }
      })
    })
  },
  methods: {
    scrolling () {
      const isMobile = window.matchMedia('(max-width: 750px)')

      if (isMobile.matches) {
        return false
      }

      const firstLi = this.$refs.li[0]
      const listWidth = firstLi.offsetWidth * this.list.length
      let slidesVisible = this.$el.offsetWidth / listWidth
      slidesVisible = Math.ceil(slidesVisible)

      if (slidesVisible >= 1) {
        const list = []
        for (let i = 0; i < slidesVisible; i++) {
          list.push(...this.list)
        }

        this.list = [
          ...this.list,
          ...list
        ]
      }

      firstLi.animate(
        {
          marginLeft: [0, `${listWidth * -1}px`]
        },
        {
          duration: 20000,
          iterations: Infinity
        }
      )
    },
    goTop () {
      document.documentElement.scrollTop = 0
    }
  }
}
</script>
